/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Modes({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" fillRule="evenodd" clipPath="url(#Modes_svg__a)" clipRule="evenodd"><path d="M8 2.4a.6.6 0 0 0-.6.6v10a.6.6 0 0 0 .6.6A5.6 5.6 0 1 0 8 2.4M12.4 8a4.4 4.4 0 0 1-3.8 4.36V3.64A4.4 4.4 0 0 1 12.4 8" /><path d="M8 .4a7.6 7.6 0 1 0 0 15.2A7.6 7.6 0 0 0 8 .4M1.6 8a6.4 6.4 0 1 1 12.8 0A6.4 6.4 0 0 1 1.6 8" /></g><defs><clipPath id="Modes_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;